const REFERRAL_REQUEST_TTL = 21; // days
const MAX_REFERRAL_REQUESTS_PER_PERIOD = 1;
const MEMBER_MAX_REFERRAL_REQUESTS_PER_PERIOD = 99;
const MAX_REFERRALS_PER_PERIOD = 10;

module.exports = {
  REFERRAL_REQUEST_TTL,
  MAX_REFERRAL_REQUESTS_PER_PERIOD,
  MEMBER_MAX_REFERRAL_REQUESTS_PER_PERIOD,
  MAX_REFERRALS_PER_PERIOD,
};
